var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHfaGraphWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 601.841 166.711",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 65",
    d: "M1.00001 63.8613C12.4711 63.411 56.2343 62.9857 57.7022 63.8613C87.2337 69.1146 97.339 89.3345 109.447 108.848C121.556 128.362 124.423 138.119 146.091 154.63C162.27 166.96 173.494 167.389 189.745 163.637C214.163 157.998 226.719 83.2854 237.541 69.0703C254.11 47.3051 261.857 47.9118 283.793 54.6667C305.73 61.4217 311.069 79.5776 326.76 79.5776C346.516 79.5776 353.207 69.0703 368.233 61.4217C375.348 57.8001 399.41 38.1548 414.068 43.4083C428.725 48.6618 440.577 81.9385 461.226 96.0893C475.274 105.716 499.145 73.5734 513.165 78.0766C531.646 78.0766 532.97 89.941 547.946 83.9371C547.946 83.9371 559.584 84.063 568.29 62.3157C578.805 36.0472 580.429 5.38049 590.913 1.52296C594.11 0.346827 600.841 1.52322 600.841 1.52322",
    stroke: "var(--stroke-0, #2E5EAF)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfaGraphWave1);
export default __webpack_public_path__ + "static/media/hfa_graph_wave1.1a5c0e447f557085efce0b4e729e52b8.svg";
export { ForwardRef as ReactComponent };